<template>
  <div class="timeline large">
    <div class="time-line"></div>
    <div class="time-point" v-for="(point, index) in points" :key="point.key">
      <div class="pip"></div>
      <div
        class="popup"
        :class="{ first: index === 0, last: index === points.length - 1 }"
      >
        <img :src="point.info.image" alt="" />
        <h2>{{ point.info.year }}</h2>
        <p>
          {{ point.info.description }}
        </p>
      </div>
      <p>{{ point.info.year }}</p>
    </div>
  </div>
</template>

<script>
import points from "@/data/home";

export default {
  name: "TimelineLarge",
  data() {
    return {
      points
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.time-line {
  position: absolute;
  width: 100%;
  border: 2px solid $gold;
  left: 0;
  top: calc(30% - 2px);
}
.timeline.large {
  position: relative;
  grid-area: timeline-large;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.time-point {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 3rem;
  position: relative;
}

.time-point:first-of-type {
  margin-left: 2rem;
}

.time-point > p {
  font: normal 1.625rem/3rem $courier;
  color: $gold;
  margin: 0;
}

.pip {
  width: 2.5rem;
  height: 2.5rem;
  border: 5px solid $gold;
  background: $black;
  border-radius: 50%;
  z-index: 2;
}

.pip:hover {
  background: $gold;
  cursor: pointer;
}

.pip:hover + .popup {
  opacity: 1;
  z-index: 1;
}

.pip.active {
  background: $gold;
}

.popup {
  opacity: 0;
  position: absolute;
  z-index: 0;
  background: $gold;
  padding: 1rem;
  transition: all 0.2s ease-in-out;
  bottom: 175%;
}

.popup.first {
  transform: translateX(25%);
}

.popup.last {
  transform: translateX(-25%);
}

.popup::after {
  content: "";
  position: absolute;
  top: 99%;
  left: 50%;
  margin-left: -3rem;
  border-width: 3rem;

  border-style: solid;
  border-color: $gold transparent transparent transparent;
}

.popup.first::after {
  margin-left: -35.25%;
}

.popup.last::after {
  margin-left: 15.25%;
}

.popup h2 {
  // font: normal 1.6875rem/2rem $courier;
  font: normal 1.5rem $courier;
  margin: 0.25rem 0;
  color: $black;
}

.popup p {
  // font: normal 1.125rem/1.5rem $caslon;
  font: normal 1rem/1.25rem $caslon;
  margin: 0.25rem 0 0 0;
  color: $black;
}
@media screen and (max-width: 1024px) {
  .timeline.large {
    display: none;
  }
}
</style>
